import { z } from 'zod';
import type { TFunction } from 'i18next';

const TAG_MAX_LENGTH = 80;

// A factory, not a module-scope const: building the schema at import time would bake
// in whatever language was active then, and the messages could never follow a change.
export const buildQuickEditProjectFormSchema = (t: TFunction<'projects'>) =>
  z.object({
    name: z
      .string()
      .trim()
      .min(1, t('editProject.quickEditProjectModal.projectNameIsRequired'))
      .max(255, t('editProject.quickEditProjectModal.nameIsTooLong')),
    tags: z.array(
      z
        .string()
        .trim()
        .min(1)
        .max(
          TAG_MAX_LENGTH,
          t('editProject.quickEditProjectModal.tagMaxLength', { max: TAG_MAX_LENGTH }),
        ),
    ),
  });

export type QuickEditProjectFormData = z.infer<ReturnType<typeof buildQuickEditProjectFormSchema>>;
